let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1zZsr")).then(() => parcelRequire('7PaJY'));